import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Axios from "../../config/AxiosConfig";
import { toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddBookingModal = ({ isOpen = true, onClose, refreshData }) => {
  const [users, setUsers] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [formData, setFormData] = useState({
    bookedBy: "",
    restaurantId: "",
    bookingDateTime: "",
    numberOfGuests: "",
    phoneNumber: "",
    email: "",
    fullName: "",
    message: "",
  });

  useEffect(() => {
    fetchUsers();
    fetchRestaurants();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await Axios.get("/super-admin/select-users");
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchRestaurants = async () => {
    try {
      const response = await Axios.get("/super-admin/select-restaurants");
      setRestaurants(response.data.restaurants);
    } catch (error) {
      console.error("Error fetching restaurants:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const response = await Axios.post("/super-admin/restaurant-booking", formData);
      toast.success(response.data.message || "Booking Created Successfully!");
      refreshData();
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating booking");
      console.error("Error creating booking:", error);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={onClose} className="add-booking-modal" overlayClassName="add-booking-overlay">
        <div className="add-booking-modal-header">
          Add Booking
          <button className="add-booking-close-btn" onClick={onClose}>{"\u00D7"}</button>
        </div>

        <div className="add-booking-modal-content">
          <div className="add-booking-form-group">
            <label>Select User</label>
            <select name="bookedBy" value={formData.bookedBy} onChange={handleChange}>
              <option value="">Select User</option>
              {users.map((user) => (
                <option key={user._id} value={user._id}>
                  {user.username}
                </option>
              ))}
            </select>
          </div>

          <div className="add-booking-form-group">
            <label>Select Restaurant</label>
            <select name="restaurantId" value={formData.restaurantId} onChange={handleChange}>
              <option value="">Select Restaurant</option>
              {restaurants.map((restaurant) => (
                <option key={restaurant._id} value={restaurant._id}>
                  {restaurant.restaurantName}
                </option>
              ))}
            </select>
          </div>

          <div className="add-booking-form-group">
            <label>Booking Date & Time</label>
            <input
              type="datetime-local"
              name="bookingDateTime"
              value={formData.bookingDateTime}
              onChange={handleChange}
            />
          </div>

          <div className="add-booking-form-group">
            <label>Number of Guests</label>
            <input type="number" name="numberOfGuests" value={formData.numberOfGuests} onChange={handleChange} />
          </div>

          <div className="add-booking-form-group">
            <label>Full Name</label>
            <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} />
          </div>

          <div className="add-booking-form-group">
            <label>Phone Number</label>
            <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} />
          </div>

          <div className="add-booking-form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} />
          </div>

          <div className="add-booking-form-group">
            <label>Message (Optional)</label>
            <textarea name="message" value={formData.message} onChange={handleChange}></textarea>
          </div>
        </div>

        <div className="add-booking-modal-footer">
          <button className="add-booking-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="add-booking-save-btn" onClick={handleSubmit}>Save</button>
        </div>
      </Modal>
    </>
  );
};

export default AddBookingModal;
